import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

const SubjectLinesModal = ({
    open,
    onClose,
    options,
    usedChips,
    onCheckboxChange
}) => {
    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 700,
                    maxWidth: "90vw",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: "70vh",
                    overflowY: "auto"
                }}
            >
                <Typography variant="h4" mb={3}>
                    Select Additional Fields
                </Typography>

                <Grid container spacing={1}>
                    {options.map((option) => (
                        <Grid item xs={6} key={option}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={usedChips.includes(option)}
                                        onChange={(e) =>
                                            onCheckboxChange(
                                                option,
                                                e.target.checked
                                            )
                                        }
                                    />
                                }
                                label={option}
                            />
                        </Grid>
                    ))}
                </Grid>

                <Box mt={3} textAlign="right">
                    <Button variant="contained" onClick={onClose}>
                        Close
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default SubjectLinesModal;